import { resetRequestState } from "../../utils/resetRequestState";
import { State } from "./types";

function handleEditMilestone(state: State): State {
  return state.map((result) => ({
    ...result,
    request: resetRequestState(),
  }));
}

export { handleEditMilestone };
